import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  BiData,
  ShowDeviationAnywayClickBiEvent,
  OpenBrowsingModeClickBiEvent,
} from '@wix/da-bi/pkg/events';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { HiddenProps } from './types';
import HiddenLayout from './HiddenLayout';

import hiddenStyles from './Hidden.scss';

const MatureBlockedOverlay: React.FC<HiddenProps> = ({
  deviation,
  disableMatureFilter,
  overrideMatureFilter,
  pushUserSettingsModal,
  ...props
}) => {
  const { t } = useTranslation();

  // todo: this is essentially the same as nsfg's 13+
  return (
    <HiddenLayout
      icon={<HiddenIcon size={IconSize.HUGE} />}
      text={t('deviationview.blocked.mature.text')}
      button={
        <GhostButton
          variant="main"
          size="medium"
          onClick={ev => {
            ev.preventDefault();
            overrideMatureFilter(deviation.deviationId);
          }}
          biData={BiData<ShowDeviationAnywayClickBiEvent>({
            evid: 305,
            typeid: deviation.typeId,
            itemid: deviation.deviationId,
          })}
        >
          {t('deviationview.blocked.showDeviationAnyway')}
        </GhostButton>
      }
      secondaryButton={
        <TextButton
          className={hiddenStyles['secondary-button']}
          size="medium"
          variant="main"
          onClick={pushUserSettingsModal}
          biData={BiData<OpenBrowsingModeClickBiEvent>({
            evid: 306,
            typeid: deviation.typeId,
            itemid: deviation.deviationId,
          })}
        >
          {/* this uses Trans because design wants a bolded component in the text */}
          {/* note: this needs `white-space: pre-wrap` on it to prevent losing whitespace */}
          <Trans i18nKey={'deviationview.blocked.openContentFilterModal'} />
        </TextButton>
      }
      deviation={deviation}
      {...props}
    />
  );
};
MatureBlockedOverlay.displayName = 'MatureBlockedOverlay';

export default MatureBlockedOverlay;
